import React, { useState } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { BaseServiceComponentProps } from '@/pages/benchmark/types/commom';
import moment from 'moment';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
import { useParams } from 'umi';
import { getCompleteDateValue } from '@/pages/dashboard/utils/utils';
import { DATA_TYPE_OBJECT } from '@home/utils/common';
import { getFilterConfig } from '../utils';

export interface IRollingRetentionServiceProps
  extends BaseServiceComponentProps {
  metric: string;
  gameCodes: string[];
  dataSource: string;
  [key: string]: any;
}

export default function RollingRetentionService(
  props: IRollingRetentionServiceProps,
) {
  const {
    style,
    className,
    refreshKey,
    interval,
    dataKey = 'data',
    api,
    children,
    filter,
    metric,
    gameCodes,
    dataSource = 'dashboard',
    extraParams = {},
    filterConfig,
    ...resetProps
  } = props || {};

  const { studioId } = useParams() || {} as any;
  const [filterCarry, setFilterCarry] = useState<any>({}); 

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={{ ...props.data }}
        dataKey={dataKey}
        refreshKey={refreshKey}
        interval={interval}
        filterLoading={false}
        filterVal={filter}
        formatData={(data: any) => {
          const newData: any = {
            [metric]: [],
            [`${metric}_last`]: [],
          };
          // 判断是否返回了有数据，但是值都是空的
          const hasData = data?.some(
            (item: any) =>
              item?.metrics[metric]?.value ||
              item?.metrics[metric]?.last_value,
          );
          if (hasData) {
            data?.forEach((item: any) => {
              const { date, metrics } = item;
              // 计算上周期时间
              const lastDataOfMonth = moment(date)
                .subtract(4, 'week')
                .format('YYYY-MM-DD');

              newData[metric].push({ date, value: metrics[metric].value });

              newData[`${metric}_last`].push({
                date: lastDataOfMonth,
                value: metrics[metric].last_value,
              });
            });
          }
          return newData;
        }}
        beforeRequest={(data) => {
          const { filterVal } = data;
          const { start_time, end_time, date_type, isSingle, payType, selectorList } = filterVal || {};
          let startDate = dateTimeFormat(start_time, 'day');
          const rangeTime = [start_time, end_time];
          const time_type = DATA_TYPE_OBJECT[date_type];
          // 补齐逻辑
          if (isSingle) {
            const rangeTimeArr = getCompleteDateValue(rangeTime, time_type);
            startDate = dateTimeFormat(rangeTimeArr[0], 'day');
          }

          const params = {
            studio_code: studioId,
            game_codes: gameCodes,
            data_source: dataSource,
            period: date_type,
            start_time: startDate,
            end_time: dateTimeFormat(end_time, 'day'),
            metrics: [metric],
            filters: {
              zone_list: ['255'],
              market_list: ['255'],
              channel_list: ['255'],
              os_list: ['255'],
              category_list: ['255'],
              product_list: ['255'],
            },
            ...extraParams
          };
          // 筛选器过滤
          if(filterConfig){
            const processedFilters = getFilterConfig(selectorList, filterConfig);
            setFilterCarry(processedFilters);
            params.filters = processedFilters;
          }
          if (payType) {
            // 增加筛选器参数
            params.filters.custom_filters = [
              {
                "key": "payment_type",
                "filter_list": [payType]
              }
            ];
          }
          return params;
        }}
        trackData={[]}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...(resetProps || {}),
            filter,
            filterCarry,
          }),
        )}
      </Service>
    </div>
  );
}
